import {
  PublicForgotUsernameRequest,
  PublicMfaResetSupportRequest,
  PublicPasswordUpdateRequest,
} from "@shared/zod/schemas/requests/user"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const passwordResetRequest = (data: { email?: string; username?: string }): Promise<void> => {
  return axiosPublic({
    url: "public/user/passwordreset",
    method: "post",
    data,
  }).then(() => undefined)
}

/** Sends a public forgot-username request for the provided email address. */
export const forgotUsernameRequest = (data: PublicForgotUsernameRequest): Promise<void> => {
  return axiosPublic({
    url: "public/user/forgotusername",
    method: "post",
    data,
  }).then(() => undefined)
}

export const passwordResetUpdate = async (data: PublicPasswordUpdateRequest): Promise<void> => {
  await axiosPublic({
    url: "public/user/passwordupdate",
    method: "post",
    data,
  })

  return undefined
}

export const mfaResetSupportRequest = async (data: PublicMfaResetSupportRequest): Promise<void> => {
  await axiosPublic({
    url: "public/user/mfa-reset-support",
    method: "post",
    data,
  })
}
